<template>
  <v-container>
    <div class="mt-5">      
      <!-- <v-badge color="red" v-if="pendingCount > 0">
        {{ pendingCount }} pending
      </v-badge> -->
      <v-btn end right @click="openCameraDialog" color="primary" class="mb-4">
        <v-icon left>mdi-camera</v-icon>
        Scan Business Card
      </v-btn>
      <camera-dialog 
        ref="cameraDialog" 
        @data-extracted="populateForm" 
        @processing-error="handleProcessingError"
      />
      <v-progress-linear
        v-if="syncingInProgress"
        :value="progress"
        color="green"
        height="10"
      ></v-progress-linear>
    </div>
    <v-form ref="form" v-model="valid">
      <v-row :no-gutters="$vuetify.breakpoint.xsOnly">
        <v-col cols="12" sm="6">
          <v-text-field
            label=" Lead Contact Name"
            v-model="lead.SAL_CONTACT_NAME"
            :rules="nameRules"
            outlined
            required
            clearable
          ></v-text-field>
         </v-col>
        <v-col cols="12"  sm="6">
          <v-text-field
            label="Lead Company Name"
            v-model="lead.SAL_CUSTOMER_NAME"
            :rules="nameRules"
            outlined
            required
            clearable
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6"> 
          <v-text-field
            label="Lead Contact Email"
            v-model="lead.SAL_BILL_EMAIL"
            :rules="emailRules"
            outlined
            required
            clearable
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6"> 
          <v-text-field
            label="Lead Mobile Number"
            v-model="lead.SAL_BILL_TEL1"
            :rules="mobileRules"
            outlined
            required
            clearable
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6"> 
          <v-textarea
          label="Lead Address"
          v-model="lead.SAL_BILL_ADDRESS"
          outlined
          rows="3"
          clearable
          ></v-textarea>
        </v-col>
        <v-col cols="12" sm="6">
          <v-textarea
          label="Narration"
          v-model="lead.SAL_NARRATION"
          outlined
          rows="3"
          clearable
          ></v-textarea>
        </v-col>
        
        <v-col cols="12"  md="3" sm="3">
          <v-text-field
          label="Website"
          v-model="lead.SAL_BILL_WEBSITE"
          :rules="webRules"
          outlined
          clearable
          ></v-text-field>
        </v-col>
        <v-col cols="12"  md="3" sm="3">
          <v-text-field
          label="Assessed Success Possibility (ASP %)"
          v-model="lead.SAL_ASP"
          :rules="aspRules"
          outlined
          clearable
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="3"> 
          <v-autocomplete
            label="Company Residing Country"
            v-model="lead.SAL_BILL_COUNTRY"
            :items="countries"
            item-text="name"
            item-value="code"
            required
            outlined
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3" sm="3">
          <v-autocomplete
            label="Company Management Country"
            v-model="lead.SAL_MANAGEMENT_DOCNO"
            :items="countries"
            item-text="name"
            item-value="code"
            required
            outlined
            clearable
          ></v-autocomplete>
        </v-col>        
      </v-row>
      <v-row>
        <v-col cols="12" sm="3">
          <v-autocomplete
            label="Grade"
            v-model="lead.SAL_LEAD_GRADE_DOCNO"
            :items="grades"
            item-text="name"
            item-value="id"
            required
            outlined
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="3">
          <v-autocomplete
            label="Base Grade"
            v-model="lead.SAL_LEAD_BASEGRADE_DOCNO"
            :items="baseGrades"
            item-text="name"
            item-value="id"
            required
            outlined
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="3">
          <v-autocomplete
            label="Enquiry Source"
            v-model="lead.SAL_LEAD_SOURCE_DOCNO"
            :items="leadSources"
            item-text="name"
            item-value="code"
            required
            outlined
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="3">
          <v-autocomplete
            label="Industry"
            v-model="lead.SAL_LEAD_INDUSTRY_DOCNO"
            :items="leadIndustries"
            item-text="name"
            item-value="code"
            required
            outlined
            clearable
          ></v-autocomplete>
        </v-col>

        <v-col cols="12" sm="6">
          <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="lead.SAL_BID_DUEDATE"
                label="Next Follow-up Date"
                prepend-icon="mdi-calendar"
                readonly
                outlined
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
          <v-date-picker
            v-model="lead.SAL_BID_DUEDATE"
            @input="menu = false"
           
          ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6">
          <!-- <v-file-input
            label="Business Image"
            prepend-icon="mdi-camera"
            accept="image/*"
            @change="convertToBase64"
          ></v-file-input>
          <v-img v-if="lead.SAL_LPO_BASE64 " :src="lead.SAL_LPO_BASE64 " max-height="300" contain class="mt-2"></v-img>
      -->   <v-file-input
            v-model="imageFile"
            label="Business Image"
            prepend-icon="mdi-camera"
            accept="image/*"
            @change="handleFileChange"
            :clearable="true"
            :show-size="true"
            outlined
          ></v-file-input>

          <v-img 
            v-if="lead.SAL_LPO_BASE64" 
            :src="lead.SAL_LPO_BASE64" 
            max-height="300" 
            contain 
            class="mt-2"
          ></v-img>

          <div v-if="imageFileName" class="mt-2">
            File name: {{ imageFileName }}
          </div>

          <!-- <v-btn 
            v-if="lead.SAL_LPO_BASE64" 
            @click="removeImage" 
            color="error" 
            class="mt-2"
          >
            Remove Image
          </v-btn> -->          
        </v-col>
      </v-row>
      <v-row>
      <v-col cols="12" sm="6">
        <v-select
          v-model="lead.leadForCompany"
          :items="companies"
          label="Lead for Company"
          outlined
          required
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
            label="Lead for User"
            hint="if you are creating this lead for any of your Colleague"
            v-model="lead.leadForUser"
            outlined            
            clearable
          ></v-text-field>
      </v-col>
    </v-row>
      <v-row justify="space-between">
        <v-col cols="4">
          <v-btn color="primary" block @click="submit">Submit</v-btn>
        </v-col>

        <v-col cols="4">
          <v-btn color="error" block @click="resetForm">Reset</v-btn>
        </v-col>

        <v-col cols="4">
          <v-btn color="warning" block @click="goback">Cancel</v-btn>
        </v-col>
      </v-row>
  </v-form>

  </v-container> 
</template>
  
  <script>
  // import secure_axios from "../services/secure_axios";
  import dynamic_axios from "../services/dynamic_axios";
  import CameraDialog from './CameraDialog.vue'; // Make sure the path is correct
  export default {    
    components: {
    CameraDialog
    },
    data() {
      return {
        valid: false,
        totalSubmissions: 0,
        syncedSubmissions: 0,
        syncingInProgress: false,
      
        companies: [
          { text: "Triton Middle East LLC", value: "triton" },
          { text: "Skymat Building Materials Trading LLC", value: "skymat" },
        ],
        lead: {
          leadForCompany: "triton", // Default selection
          leadForUser:null,
          SAL_CONTACT_NAME: null,
          SAL_CUSTOMER_NAME: null,
          SAL_BILL_EMAIL: null,
          SAL_BILL_TEL1: null,
          SAL_BILL_ADDRESS: null,
          SAL_BILL_COUNTRY: null,
          SAL_NARRATION:null,
          SAL_LEAD_GRADE_DOCNO: null,
          SAL_LEAD_BASEGRADE_DOCNO: null,
          SAL_BID_DUEDATE: new Date().toISOString().slice(0, 10),
          SAL_LPO_BASE64: null,
          SAL_REFERENCE1:null,
          SAL_ASP: '',
          SAL_MANAGEMENT_DOCNO: null,
          SAL_LEAD_SOURCE_DOCNO:  null,
          SAL_LEAD_INDUSTRY_DOCNO:  null,
          SAL_BILL_WEBSITE: null,
          SAL_BILL_MAP: null,
          DocStatus:null,
        },
        imageFile: null,
        imageFileName: '',
        nameRules: [v => !!v || 'Field is required'],
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        mobileRules: [v => !!v || 'Mobile number is required'],
        webRules: [
        v => !v || /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z]{2,6}(\/[^\s]*)?$/i.test(v) || 'Website must be a valid URL'
        ],
        aspRules: [
        // v => !!v || 'ASP is required', // Checks for non-empty value
        v => !isNaN(parseFloat(v)) && isFinite(v) || 'ASP must be a number', // Checks if the value is a number
        v => (v >= 0 && v <= 100) || 'ASP must be between 0 and 100', // Checks if the value is between 0 and 100
        ],
        leadSources:[],
        leadIndustries:[],
        countries: [],
        grades: [],
        baseGrades: [],
        menu: false,
        isLoading: false, // To indicate loading state
        errorMessage: '', // To show error messages to users
        company:'triton'
      };
    },
    watch: {
      lead: {
        handler(newVal) {
          localStorage.setItem('leadDraft', JSON.stringify(newVal));
        },
        deep: true
      }
    },
    computed: {   
      sessionAPI() {
        // return this.$store.getters.sessionAPI;
        return "https://tritonfactsapi.ngrok.io/";
      },
      myLocation() {
        return this.$store.getters.myLocation;
      },
      thisUser() {
        return this.$store.getters.factsuser;
      },
      progress() {
        if (this.totalSubmissions === 0) return 0;
        return (this.syncedSubmissions / this.totalSubmissions) * 100;
      },
      pendingCount() {
        const pendingSubmissions = JSON.parse(localStorage.getItem('pendingSubmissions') || '[]');
        return pendingSubmissions.length;
      }
    },
    methods: {
      isDateValidOrEmpty(date) {
        if (!date) return true; // If no date is provided, it's considered valid

        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time to midnight
        const selectedDate = new Date(date);

        return selectedDate >= today; // True if the selected date is today or in the future
      },
      async submit() {
        console.log("lead submit");
        if (!this.$refs.form.validate()) {
          return; // Stop if form is invalid
        }

      this.isLoading = true; 
      // Initialize the data object
      const leadData = {
        SAL_CONTACT_NAME: this.lead.SAL_CONTACT_NAME,
        SAL_CUSTOMER_NAME:  this.lead.SAL_CUSTOMER_NAME,
        SAL_BILL_EMAIL:  this.lead.SAL_BILL_EMAIL,
        SAL_BILL_TEL1:  this.lead.SAL_BILL_TEL1,
        SAL_BILL_ADDRESS : this.lead.SAL_BILL_ADDRESS,
        SAL_BILL_COUNTRY:  this.lead.SAL_BILL_COUNTRY,
        SAL_NARRATION:  this.lead.SAL_NARRATION,
        SAL_LEAD_GRADE_DOCNO:  this.lead.SAL_LEAD_GRADE_DOCNO,
        SAL_LEAD_BASEGRADE_DOCNO:  this.lead.SAL_LEAD_BASEGRADE_DOCNO,
        SAL_LPO_BASE64:  this.lead.SAL_LPO_BASE64,
        SAL_REFERENCE1: this.lead.SAL_REFERENCE1,
        SAL_ASP: this.lead.SAL_ASP,
        SAL_BILL_WEBSITE: this.lead.SAL_BILL_WEBSITE,
        SAL_MANAGEMENT_DOCNO: this.lead.SAL_MANAGEMENT_DOCNO,
        SAL_LEAD_SOURCE_DOCNO: this.lead.SAL_LEAD_SOURCE_DOCNO,
        SAL_LEAD_INDUSTRY_DOCNO:  this.lead.SAL_LEAD_INDUSTRY_DOCNO,
        smancode: this.thisUser.USER_DEFAULT_SMAN_DOCNO,
        empcode: this.thisUser.USER_EMP_DOCNO,
        smanname: this.thisUser.SMAN_DESC,
        crbyname: this.thisUser.USER_NAME,
        crbydesg: this.thisUser.USER_UD_LABEL2,
        myloc: `${this.myLocation.latitude}, ${this.myLocation.longitude}`,
        createdby: this.thisUser.USER_LOGINID,
        leadForCompany:this.lead.leadForCompany,
        leadForUser:this.lead.leadForUser,
      };

      // Conditionally add SAL_BID_DUEDATE if it's valid or empty
      if (this.isDateValidOrEmpty(this.lead.SAL_BID_DUEDATE)) {
        leadData.SAL_BID_DUEDATE = this.lead.SAL_BID_DUEDATE;
      }
      if (!navigator.onLine) {
        const pendingSubmissions = JSON.parse(localStorage.getItem('pendingSubmissions') || '[]');
        pendingSubmissions.push(leadData);
        localStorage.setItem('pendingSubmissions', JSON.stringify(pendingSubmissions));
        this.$toast.warning("Saved locally. Will sync when online.");
        this.resetForm();
      } else {
          try {
          // const response = await secure_axios.post(this.sessionAPI+"newlead", leadData);
          const response = await dynamic_axios.post("/newlead", leadData, {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    apiName: this.company
                });
          
          if(response.status === 201) {
            // Handle successful response
            console.log("Lead added successfully", response.data);
            this.$toast.success(`Lead added successfully, with no:${response.data.id}.`);
            this.$emit('lead-added');
            localStorage.removeItem('leadDraft'); 
            this.resetForm();
          }
        } catch (error) {
            this.handleError(error);
            this.$toast.error("An error occurred: " + error.message);
          } finally {
            this.isLoading = false; 
          }
        }
      },
      async syncData() {
        let pendingSubmissions = JSON.parse(localStorage.getItem('pendingSubmissions') || '[]');
        if (pendingSubmissions.length === 0) {
          return;
        }

        this.totalSubmissions = pendingSubmissions.length;
        this.syncedSubmissions = 0;
        this.syncingInProgress = true;

        const successfullySyncedIndices = [];

        // Using forEach to attempt syncing each item
        await Promise.all(pendingSubmissions.map(async (data, index) => {
          try {
            // const response = await secure_axios.post(this.sessionAPI + "newlead", data);
            const company = 'triton';
            const response = await dynamic_axios.post("/newlead", data, {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    apiName: company
                });
            if (response.status === 201) {
              console.log("Lead synced successfully", response.data);
              this.syncedSubmissions++;
              successfullySyncedIndices.push(index);
            }
          } catch (error) {
            console.error("Error syncing data", error);
          }
        }));

        // Remove successfully synced items in reverse order to avoid indexing issues
        successfullySyncedIndices.reverse().forEach(index => {
          pendingSubmissions.splice(index, 1);
        });

        // Notifications
        if (this.syncedSubmissions === this.totalSubmissions) {
          this.$toast.success("All leads synced successfully!");
        } else {
          const failedCount = this.totalSubmissions - this.syncedSubmissions;
          this.$toast.error(`${failedCount} lead(s) could not be synced. Please try again.`);
        }

        // Update pending submissions in localStorage
        localStorage.setItem('pendingSubmissions', JSON.stringify(pendingSubmissions));
        this.syncingInProgress = false;
      },

      // async syncData() {
      //   let pendingSubmissions = JSON.parse(localStorage.getItem('pendingSubmissions') || '[]');
      //   if (pendingSubmissions.length === 0) {
      //     return;
      //   }

      //   this.totalSubmissions = pendingSubmissions.length;
      //   this.syncedSubmissions = 0;
      //   this.syncingInProgress = true;

      //   // Use a while loop for safer removal of items
      //   while (pendingSubmissions.length > 0) {
      //     try {
      //       const data = pendingSubmissions[0]; // Always take the first item
      //       const response = await secure_axios.post(this.sessionAPI + "newlead", data);
            
      //       if (response.status === 201) {
      //         console.log("Lead synced successfully", response.data);
      //         this.syncedSubmissions++;
      //         // Remove the successfully synced submission
      //         pendingSubmissions.shift();
      //       } else {
      //         // If failed, leave it in the array and break the loop
      //         break;
      //       }
      //     } catch (error) {
      //       console.error("Error syncing data", error);
      //       // Leave the failed submission in the array and break the loop
      //       break;
      //     }
      //   }

      //   // Notifications
      //   if (this.syncedSubmissions === this.totalSubmissions) {
      //     this.$toast.success("All leads synced successfully!");
      //   } else {
      //     const failedCount = this.totalSubmissions - this.syncedSubmissions;
      //     this.$toast.error(`${failedCount} lead(s) could not be synced. Please try again.`);
      //   }

      //   // Update pending submissions in localStorage
      //   localStorage.setItem('pendingSubmissions', JSON.stringify(pendingSubmissions));
      //   this.syncingInProgress = false;
      // },

      // async syncData() {
      //   let pendingSubmissions = JSON.parse(localStorage.getItem('pendingSubmissions') || '[]');
      //   console.log("PENDINGSUBMISSION",pendingSubmissions); 
      //   if (!pendingSubmissions || pendingSubmissions.length === 0) {
      //     // this.$toast.info("No pending submissions to sync.");
      //     return; // Exit the function if there's nothing to sync
      //   }
      //   this.totalSubmissions = pendingSubmissions.length;
      //   this.syncedSubmissions = 0;
      //   this.syncingInProgress = true;

      //   for (let i = 0; i < pendingSubmissions.length; ) {
      //     try {
      //       const data = pendingSubmissions[i];
      //       const response = await secure_axios.post(this.sessionAPI + "newlead", data);
      //       if (response.status === 201) {
      //         console.log("Lead synced successfully", response.data);
      //         this.syncedSubmissions++;
      //         pendingSubmissions.splice(i, 1); // Remove this submission from the array
      //       } else {
      //         i++; // Move to the next submission
      //       }
      //     } catch (error) {
      //       console.error("Error syncing data", error);
      //       // i++; // Move to the next submission
      //     }
      //   }

      //   // Notifications
      //   if (this.syncedSubmissions === this.totalSubmissions ) {
      //     this.$toast.success("All leads synced successfully!");
      //   } else {
      //     const failedCount = this.totalSubmissions - this.syncedSubmissions;
      //     this.$toast.error(`${failedCount} lead(s) could not be synced. Please try again.`);
      //   }

      //   // Update pending submissions in localStorage
      //   localStorage.setItem('pendingSubmissions', JSON.stringify(pendingSubmissions));
      //   this.syncingInProgress = false;
      // },
      resetForm() {
        this.lead = {
          SAL_CONTACT_NAME: '',
          SAL_CUSTOMER_NAME: '',
          SAL_BILL_EMAIL: '',
          SAL_BILL_TEL1: '',
          SAL_BILL_COUNTRY: '',
          SAL_NARRATION: '',
          SAL_LEAD_GRADE_DOCNO: '',
          SAL_LEAD_BASEGRADE_DOCNO: '',
          SAL_BID_DUEDATE: '',
          SAL_LPO_BASE64: '',
          SAL_REFERENCE1: '',
          SAL_ASP:'',
          SAL_BILL_WEBSITE: null,
          leadForUser:null,
          leadForCompany:null,
        };
        this.$refs.form.reset();
      },
      goback() {
        this.$router.go(-1);
      }, 
      convertToBase64(file) {
        if (!file) return;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e => {
          this.lead.SAL_LPO_BASE64 = e.target.result;
        };
      },
      handleFileChange(file) {
        if (file) {
          this.imageFileName = file.name;
          this.convertToBase64(file);
        } else {
          this.removeImage();
        }
      },
      // convertToBase64(file) {
      //   const reader = new FileReader();
      //   reader.onload = (e) => {
      //     this.lead.SAL_LPO_BASE64 = e.target.result;
      //   };
      //   reader.readAsDataURL(file);
      // },
      removeImage() {
        this.lead.SAL_LPO_BASE64 = null;
        this.imageFile = null;
        this.imageFileName = '';
      },

     
      async fetchLeadSources() {
        try {
            // const response = await secure_axios.get(this.sessionAPI + "lead-sources");  // Update with correct API URL
            const response = await dynamic_axios.get(`/lead-sources`, {
              apiName:this.company  // Specify which API configuration to use
            });
            this.leadSources = response.data;
        } catch (error) {
            console.error('Error fetching leadSources:', error);
        }
      },
      async fetchLeadIndustries() {
        try {
            // const response = await secure_axios.get(this.sessionAPI + "lead-industries");  // Update with correct API URL
            const response = await dynamic_axios.get(`/lead-industries`, {
              apiName:this.company  // Specify which API configuration to use
            });
            this.leadIndustries = response.data;
        } catch (error) {
            console.error('Error fetching leadIndustries:', error);
        }
      },
      async fetchCountries() {
        try {
            // const response = await secure_axios.get(this.sessionAPI + "countries");  // Update with correct API URL
            const response = await dynamic_axios.get(`/countries`, {
              apiName:this.company  // Specify which API configuration to use
            });
            this.countries = response.data;
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
      },
      async fetchGrades() {
        try {
            // const response = await secure_axios.get(this.sessionAPI + "grades");  // Update with correct API URL
            const response = await dynamic_axios.get(`/grades`, {
              apiName:this.company  // Specify which API configuration to use
            });
            this.grades = response.data;
        } catch (error) {
            console.error('Error fetching grades:', error);
        }
      },
      async fetchBaseGrades() {
        try {
            // const response = await secure_axios.get(this.sessionAPI + "basegrades");  // Update with correct API URL
            const response = await dynamic_axios.get(`/basegrades`, {
              apiName:this.company  // Specify which API configuration to use
            });
            this.baseGrades = response.data;
        } catch (error) {
            console.error('Error fetching base grades:', error);
        }
      },
      handleError(error) {
        this.errorMessage = error.response ? error.response.data.message : 'An unexpected error occurred';
        console.error("Error:", error); // Keep this for debugging in development
      },
      handleOnline() {
        console.log("Online");
        this.syncData();
      },
      handleOffline() {
        console.log("Offline");
      },
      handleProcessingError(message) {
        this.$toast.error(message || "Failed to process the business card. Please try again.");
      },
      checkNetworkStatus() {
        if (navigator.onLine) {
          console.log("Online");
          this.syncData();
        } else {
          console.log("Offline");
        }
      },
      openCameraDialog() {
        this.$refs.cameraDialog.dialog = true;
      },
      populateForm(extractedData) {
        console.log("Event received in parent:", extractedData);
          // Populate matching fields in the form
        Object.keys(extractedData).forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(this.lead, key)) {
            this.lead[key] = extractedData[key];
          }
        });

        // Save unmatched fields or extra data in SAL_NARRATION
        if (extractedData.SAL_NARRATION) {
          this.lead.SAL_NARRATION = extractedData.SAL_NARRATION;
        }
        // Log unmatched fields for debugging
        console.log("Unmatched fields saved in SAL_NARRATION:", extractedData.SAL_NARRATION);
      },
      // populateForm(text) {
      //   // Simple parsing logic - you may need to adjust this based on the card format
      //   const lines = text.split('\n');
      //   this.lead.SAL_CONTACT_NAME = lines[0] || '';
      //   this.lead.SAL_CUSTOMER_NAME = lines[1] || '';
      //   this.lead.SAL_BILL_EMAIL = lines.find(line => line.includes('@')) || '';
      //   this.lead.SAL_BILL_TEL1 = lines.find(line => /\d{10}/.test(line)) || '';
      //   this.lead.SAL_BILL_ADDRESS = lines.slice(2).join(', ');
      // },
      handleCameraError(error) {
        console.error('Camera error:', error);
        // Show an error message to the user
        this.$toast.error('Failed to access camera. Please check your permissions.');
      },
    },
    mounted() {
      const savedLead = localStorage.getItem('leadDraft');
      if (savedLead) {
        this.lead = JSON.parse(savedLead);
      }
    },
    created() {
        this.fetchLeadSources();
        this.fetchLeadIndustries();
        this.fetchCountries();
        this.fetchGrades();
        this.fetchBaseGrades();
        window.addEventListener('online', this.handleOnline);
        window.addEventListener('offline', this.handleOffline);
        this.checkNetworkStatus();
    },
    beforeDestroy() {
      window.removeEventListener('online', this.handleOnline);
      window.removeEventListener('offline', this.handleOffline);
    },
  };
  </script>
  